import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import AdmissionContext from "../AdmissionContext";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  ShowRequiredField,
  kPButton,
  GetProvince,
  GetCity,
  GetBarangay,
} from "../global";

class AddressView extends Component {
  static contextType = AdmissionContext;

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {
  }

  regionValueChanged = async (event, value) => {

    const { address } = this.context
    address.required = false;

    this.context.SetProvince([]);
    this.context.SetCity([]);
    this.context.SetBarangay([]);

    address.region = value
    address.province = null;
    address.city = null;
    address.barangay = null;

    if (value === null) {
    } else {

      this.setState({
        isLoading: true,
      });

      this.context.SetAddress(address);
      await GetProvince(value.region_code).then((response) => {
        this.context.SetProvince(response.data);
      })

      this.setState({
        isLoading: false,
      });
    }

  };

  provinceValueChanged = async (event, value) => {

    const { address } = this.context
    address.required = false;

    this.context.SetCity([]);
    this.context.SetBarangay([]);

    address.province = value
    address.city = null;
    address.barangay = null;

    if (value === null) {
    } else {

      this.setState({
        isLoading: true,
      });

      this.context.SetAddress(address);
      await GetCity(value.province_code).then((response) => {
        this.context.SetCity(response.data);
      })

      this.setState({
        isLoading: false,
      });
    }

  };

  cityValueChanged = async (event, value) => {

    const { address } = this.context
    address.required = false;

    this.context.SetBarangay([]);
    address.barangay = null;
    address.city = value
    address.zipCode = "";

    if (value === null) {
    } else {

      address.zipCode = value.zip_code;

      this.setState({
        isLoading: true,
      });

      this.context.SetAddress(address);
      await GetBarangay(value.city_code).then((response) => {
        this.context.SetBarangay(response.data);
      })

      this.setState({
        isLoading: false,
      });
    }

  };

  barangayValueChanged = async (event, value) => {

    const { address } = this.context
    address.required = false;

    if (value === null) {
      address.barangay = {};
    } else {
      address.barangay = value
      this.context.SetAddress(address);
    }

  };

  textfieldValueChanged = (index, event) => {
    const { address } = this.context;
    address.required = false;

    if (index === 0) {
      //houseNo
      address.zipCode = event.target.value;
    } else if (index === 1) {
      //street
      address.houseNo = event.target.value;
    } else if (index === 2) {
      //street
      address.street = event.target.value;
    }


    this.context.SetAddress(address);
  };

  checkRequireFields = (index) => {
    const { address } = this.context;

    if (address.required) {
      if (index === 0) {
        if (address.region === null || address.region === "") {
          return ShowRequiredField("Region");
        }
      } else if (index === 1) {
        if (address.province === null || address.province === "") {
          return ShowRequiredField("Province");
        }
      } else if (index === 2) {
        if (address.city === null || address.city === "") {
          return ShowRequiredField("City");
        }
      } else if (index === 3) {
        if (address.barangay === null || address.barangay === "") {
          return ShowRequiredField("Barangay");
        }
      } else if (index === 4) {
        if (address.zipCode === null || address.zipCode === "") {
          return ShowRequiredField("Zip Code");
        }
      }
    }

    return null;
  };

  backButtonClicked = () => {
    this.context.btnBackClicked();
  };

  nextButtonClicked = () => {
    const { address } = this.context;
    if (
      address.region === null ||
      address.barangay === null ||
      address.city === null ||
      address.province === null ||
      address.zipCode === ""
    ) {
      address.required = true;
      this.context.SetAddress(address);
    } else {
      this.context.btnNextClicked();
    }
  };

  render() {
    const { address, region, province, city, barangay } = this.context;

    if (this.state.isLoading) {
      return (
        <Box display="flex" justifyContent="center" pt={2} css={{ height: 300 }}>
          <Grid container spacing={1}>
            <Grid item xs={1} sm={2} lg={3}></Grid>
            <Grid item xs={10} sm={8} lg={6}>
              <Box pt={20} display="flex"
                justifyContent="center">
                <CircularProgress
                  variant="indeterminate"
                  disableShrink
                  //className={classes.loading}
                  size={50}
                  thickness={4}
                />
              </Box>

              <Typography component="div">
                <Box
                  fontSize={16}
                  color="#808080"
                  display="flex"
                  justifyContent="center"
                  pt={4}
                >
                  Loading...
                </Box>
              </Typography>
            </Grid>
            <Grid item xs={1} sm={2} lg={3}></Grid>
          </Grid>

        </Box>


      );
    }

    return (
      <Box display="flex" justifyContent="center" pt={2}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
            <Card
              style={{
                border: 0,
                // minWidth: 500,
                // maxWidth: 600,
              }}
              variant="outlined"
            >
              <CardContent>
                <Typography component="div">
                  <Box
                    fontWeight={500}
                    fontSize={18}
                    color="#388e3c"
                    display="flex"
                    justifyContent="flex-start"
                  >
                    Address
                  </Box>
                </Typography>

                <Box pt={4}>
                  <Autocomplete
                    id="cboRegion"
                    options={region}
                    value={address.region}
                    getOptionLabel={(item) =>
                      item.region_name ? item.region_name : ""
                    }
                    fullWidth={true}
                    onChange={this.regionValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Region"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(0)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboProvince"
                    options={province}
                    value={address.province}
                    getOptionLabel={(item) =>
                      item.province_name ? item.province_name : ""
                    }
                    fullWidth={true}
                    onChange={this.provinceValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Province"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(1)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboCity"
                    options={city}
                    value={address.city}
                    getOptionLabel={(item) =>
                      item.city_name ? item.city_name : ""
                    }
                    fullWidth={true}
                    onChange={this.cityValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="City"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(2)}

                <Box pt={2}>
                  <Autocomplete
                    id="cboBarangay"
                    options={barangay}
                    value={address.barangay}
                    getOptionLabel={(item) =>
                      item.brgy_name ? item.brgy_name : ""
                    }
                    fullWidth={true}
                    onChange={this.barangayValueChanged}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Barangay"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>

                {this.checkRequireFields(3)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtZipCode"
                    label="Zip Code"
                    variant="outlined"
                    value={address.zipCode}
                    onChange={(e) => {
                      this.textfieldValueChanged(0, e);
                    }}
                  />
                </Box>

                {this.checkRequireFields(4)}

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtHouseNo"
                    label="House No"
                    variant="outlined"
                    value={address.houseNo}
                    onChange={(e) => {
                      this.textfieldValueChanged(1, e);
                    }}
                  />
                </Box>

                <Box pt={2}>
                  <TextField
                    fullWidth={true}
                    id="txtStreet"
                    label="Street"
                    variant="outlined"
                    value={address.street}
                    onChange={(e) => {
                      this.textfieldValueChanged(2, e);
                    }}
                  />
                </Box>

                <Box
                  justifyContent="center"
                  display="flex"
                  pt={3}
                  fontSize={14}
                >
                  <Box width={200} justifyContent="flex-start">
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.backButtonClicked();
                      }}
                    >
                      Back
                    </Button>
                  </Box>

                  <Box width={200} minHeight={100} pl={2}>
                    <Button
                      fullWidth={true}
                      style={kPButton}
                      variant="contained"
                      onClick={() => {
                        this.nextButtonClicked();
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={1} sm={2} lg={3}></Grid>
        </Grid>
      </Box>
    );
  }
}

export default AddressView;
